import { useTranslation } from "react-i18next";

export default function ApplicationsHeader() {
  const { t } = useTranslation("LegalApplicationsPage");

  return (
    <div className="flex items-center justify-between pb-4 border-b surface-base-stroke mb-5">
      <h1 className="text-display-xs content-base-primary">{t("header.title")}</h1>
    </div>
  );
}

